<template>
  <div class="mt-5">
    <div class="container-pesquisa-cobrancas">
      <v-btn color="primary" class="text-transform-none" depressed @click="adicionarCobranca">
        <v-icon>mdi-plus</v-icon>
        Adicionar cobrança
      </v-btn>
      <botao-acao hideBorder @click="abrirModalRelatorioCobrancas" v-if="podeGerarRelatorioCobrancas"
                  class="ml-5">
        <v-icon>mdi-file-document</v-icon>
        Gerar relatório
      </botao-acao>
      <paciente-ficha-cobranca-pesquisa
          :filtros="filtrosInterno"
          @buscarComFiltros="tratarEventoBuscaSimples"
      />
    </div>

    <div class="container-tabela-cobrancas">
      <paciente-ficha-cobrancas-tabela
          :itens="itens"
          :paginas="paginas"
          :total-itens="totalItens"
          :paginacao="$store.state.cobranca.resultadoBuscaTodasCobrancasInterno.paginacao"
          @acessar="tratarEventoAcessarCobranca"
          @paginar="tratarEventoPaginar"
      />
    </div>
    <cobranca-cadastro-modal
        v-if="modalAdicionarCobranca"
        v-model="modalAdicionarCobranca"
        :paciente-id="idPaciente"
        @fecharModalCadastro="fecharModalCadastroCobranca"
    />
    <cobranca-edicao-modal
        v-if="modalEditarCobranca"
        v-model="modalEditarCobranca"
        :id-cobranca="idCobranca"
        @fecharModalEdicao="fecharModalEdicaoCobranca"
    />
    <GerarRelatorioCobrancas
        v-if="modalRelatorioCobrancas"
        v-model="modalRelatorioCobrancas"
        :pacientePreSelecionado="pacienteSelecionado"
        @fecharModalRelatorio="fecharModalRelatorioCobrancas"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import {mapMutations} from 'vuex'
import {actionTypes, mutationTypes} from '@/core/constants'
import VerificarPerfilUsuario from '@/core/utils/VerificarPerfilUsuario'
import PacienteFichaCobrancasTabela
from '@/views/pages/cadastros/paciente/comum/cobrancas/PacienteFichaCobrancasTabela.vue'
import PacienteFichaCobrancaPesquisa
from '@/views/pages/cadastros/paciente/comum/cobrancas/PacienteFichaCobrancaPesquisa.vue'
import CobrancaEdicaoModal from '@/views/modais/CobrancaEdicaoModal.vue'
import CobrancaCadastroModal from '@/views/modais/CobrancaCadastroModal.vue'
import GerarRelatorioCobrancas from '@/views/modais/GerarRelatorioCobrancas.vue'


export default {
    name: 'PacienteFichaCobrancas',
    components: {
        GerarRelatorioCobrancas,
        CobrancaCadastroModal,
        CobrancaEdicaoModal,
        PacienteFichaCobrancaPesquisa, PacienteFichaCobrancasTabela
    },
    props: {
        pacienteSelecionado: Object
    },
    data() {
        return {
            filtrosInterno: this.getFiltros(),
            exibirPanel: false,
            idPaciente: null,
            itens: [],
            paginas: 0,
            totalItens: 0,
            maxInputPesquisa: 30,
            orcamentoSelecionado: {},
            orcamentoModal: false,
            modalAdicionarCobranca: false,
            modalEditarCobranca: false,
            idCobranca: null,
            podeGerarRelatorioCobrancas: false,
            modalRelatorioCobrancas: false,
        }
    },
    async mounted() {
        this.setarIdPaciente()
        this.verificarPermissoesRelatorio()
    },
    methods: {
        ...mapMutations([
            mutationTypes.COBRANCA.SET_FILTROS_BUSCA_TODAS_COBRANCAS_INTERNO,
            mutationTypes.COBRANCA.SET_PAGINACAO_BUSCA_TODAS_COBRANCAS_INTERNO,
            mutationTypes.COBRANCA.RESETA_PAGE_INTERNO,
        ]),
        setarIdPaciente() {
            if (this.$route.params.id) {
                this.idPaciente = this.$route.params.id
            }
        },
        verificarPermissoesRelatorio() {
            if (VerificarPerfilUsuario(['ADMINISTRADOR', 'RELATORIO_COBRANCA'])) {
                this.podeGerarRelatorioCobrancas = true
            }
        },
        async buscar() {
            this.setFiltrosBuscaTodasCobrancasInterno(this.getFiltrosInterno())
            await this.buscarCobrancas()
        },
        async buscarCobrancas() {
            const resposta = await this.$store.dispatch(actionTypes.COBRANCA.BUSCAR_TODAS_COBRANCAS_INTERNO, this.idPaciente)
            if (resposta) {
                this.itens = resposta.items
                this.paginas = resposta.totalPages
                this.totalItens = resposta.totalElements
            }
        },
        getFiltros() {
            return _.cloneDeep(this.$store.state.cobranca.resultadoBuscaTodasCobrancasInterno.filtros)
        },
        getFiltrosInterno() {
            return _.cloneDeep(this.filtrosInterno)
        },
        tratarEventoPaginar(paginacao) {
            this.setPaginacaoBuscaTodasCobrancasInterno(paginacao)
            this.buscar()
        },
        tratarEventoAcessarCobranca(item) {
            this.idCobranca = item.id
            this.modalEditarCobranca = true
        },
        fecharModalEdicaoCobranca() {
            this.modalEditarCobranca = false
            this.idCobranca = null
            this.buscar()
        },
        tratarEventoBuscaSimples(busca) {
            this.resetaPageInterno()
            this.filtrosInterno.statusCobranca.value = busca.statusCobranca.value
            this.filtrosInterno.tipo.value = busca.tipo.value
            this.filtrosInterno.atributo.value = busca.atributo.value
            this.filtrosInterno.conteudo.value = busca.conteudo.value
            this.buscar()
        },
        adicionarCobranca() {
            this.modalAdicionarCobranca = true
        },
        fecharModalCadastroCobranca() {
            this.modalAdicionarCobranca = false
            this.buscar()
        },
        abrirModalRelatorioCobrancas() {
            this.modalRelatorioCobrancas = true
        },
        fecharModalRelatorioCobrancas() {
            this.modalRelatorioCobrancas = false
        },
    }
}
</script>

<style scoped lang="stylus">

.titulo
  font-size 15px
  font-weight bold
  color #777

.label
  font-size 13px
  font-weight bold
  color #777

.texto
  font-size 13px
  color #777

.container-pesquisa-cobrancas
  display flex
  justify-content space-between
  align-items center
  padding 0 10px

.container-tabela-cobrancas
  padding 0 24px 16px

</style>
